import axios from 'axios'
import TokenService from '../helpers/token'

const posApiUrl = process.env.VUE_APP_VH_POS_API

const buildQueryString = query => {
  if (!query || typeof query !== 'object') return ''
  const searchParams = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value)
    }
  })
  const qs = searchParams.toString()
  return qs ? `?${qs}` : ''
}

export default {
  async generatePaymentQRCode(params, query) {
    const queryString = buildQueryString(query)
    const response = await axios.post(`${posApiUrl}/payment-qrcode${queryString}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getPaymentQRCodeSuccess(query) {
    const queryString = buildQueryString(query)
    const response = await axios.get(`${posApiUrl}/payment-qrcode/receipts-success${queryString}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async listTransactions(params) {
    const response = await axios.get(`${posApiUrl}/payment-qrcode`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async exportTransactions(params) {
    const response = await axios.get(`${posApiUrl}/payment-qrcode/export-payments`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
}

